import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { MICROSERVICES } from '@shared/constants/microservices';
import { Observable } from 'rxjs';
import { AddressRequest, AddressResponse, CompanyDetails } from './interfaces/settings.interface';
import { SettingsRepository } from './settings.repository';

@Injectable({
    providedIn: 'root',
})
export class SettingsService implements SettingsRepository {
    constructor(private http: HttpClient) {}

    updateCompanyDetails(companyDetails: CompanyDetails): Observable<CompanyDetails> {
        return this.http.patch<CompanyDetails>(`${environment.url}${MICROSERVICES.accounts}/user`, companyDetails);
    }

    getAddressById(addressId: string): Observable<AddressResponse> {
        return this.http.get<AddressResponse>(`${environment.url}${MICROSERVICES.address_book}/user-addresses/${addressId}`);
    }

    createAddress(address: AddressRequest): Observable<AddressResponse> {
        return this.http.post<AddressResponse>(`${environment.url}${MICROSERVICES.address_book}/user-addresses`, address);
    }

    updateAddress(addressId: string, address: AddressRequest): Observable<AddressResponse> {
        return this.http.patch<AddressResponse>(`${environment.url}${MICROSERVICES.address_book}/user-addresses/${addressId}`, address);
    }
}
